<template>
  <div class="wrp-layout">
    <div class="inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.wrp-layout {
  position: relative;
  bottom: 115px;
  z-index: 11;
  height: calc(100vh - 330px);
}
.inner{
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 0 29px;
}
</style>
